<template>
    <div class="menu-sidebar--level">
        <div class="menu-sidebar--item d-flex align-items-center justify-content-between">
            <a :href="item.url" class="flex-grow-0 text-white text-left" v-if="item.url && item.url != ''">
                {{ item.title }}
            </a>

            <span v-else class="flex-grow-0 text-white">
                {{ item.title }}
            </span>

            <button class="chevron btn" v-if="item.items" @click="subOpen = true">
                <svg width="10" xmlns="http://www.w3.org/2000/svg" 
                viewBox="0 0 7.778 12.728" 
                    id="gla--forward">
                    <path d="M.707.707l5.657 5.657-5.657 5.657" 
                        fill="none" stroke="#fff" 
                        stroke-width="2">
                    </path>
                </svg>
            </button>
        </div>

        <SubMenu :title="item.title" :active="subOpen" :menu-height="menuHeight"
            :items="item.items" @close="subOpen = false"/>
    </div>
</template>

<script>
    export default {
        name: 'MenuItem',
        props: {
            item: {
                type: Object|Array,
                required: true
            },
            menuHeight: {
                type: Number
            }
        },
        data(){
            return {
                subOpen: false
            }
        }
    }
</script>